export default __webpack_public_path__ + "static/media/YT-cover.1a84ad48.png";